var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<modal modal-title=\"{{::$ctrl.title}}\" instance=\"$ctrl.modal\" on-dismiss=\"$ctrl.dismiss()\"><modal-body><week-activities></week-activities></modal-body><modal-footer><button type=\"button\" ng-click=\"$ctrl.dismiss('cancel')\" ng-disabled=\"$ctrl.bus.activeCalls.length\" class=\"btn btn-primary\">Cancel</button></modal-footer></modal>";
var id1="week-activities-modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;